/**
 * Busca: aba Pesquisar do menu lateral (#MenuDrawer-search, snippets/menu-sheet.liquid; todo botão de
 * busca abre o menu nessa aba) e página de busca
 * (.search-page). Ambas usam snippets/search-form.liquid; as sugestões vêm de
 * /search/suggest?section_id=search-result (sections/search-result.liquid).
 * Depende de global.js / base.js (theme.utilities).
 *
 * Estados no <form class="search-form">:
 *   [data-query]   há texto no campo → aparece "Limpar", somem as "Buscas populares"
 *   [data-busy] buscando → "Limpar" vira spinner
 *   [data-typing]  placeholder que se digita ativo (só com a gaveta aberta)
 */
theme.search = {
  render: function () {
    this.menuSearch();
    this.mainSearchPage();
  },

  /* Liga um formulário de busca de gaveta: sugestões, placeholder que se digita e limpar.
     Devolve { show, hide } para quem controla quando ele aparece. */
  bindSheetForm: function (container) {
    var form = Object.create(theme.search.form);
    form.container = container;
    form.render();
    var typing = theme.search.typing(container.querySelector(".search-form"));
    return {
      show: function () {
        if (typing) typing.start();
        window.setTimeout(function () {
          form.searchInput.focus({ preventScroll: true });
        }, 300);
      },
      hide: function () {
        if (typing) typing.stop();
        form.clear(false);
      },
    };
  },

  /* Aba Pesquisar do menu lateral: aparece ao trocar para a aba (ou ao abrir o menu já nela);
     some ao trocar de aba ou fechar o menu */
  menuSearch: function () {
    var panel = document.getElementById("MenuDrawer-search");
    var drawer = document.getElementById("MenuDrawer");
    if (!panel || !drawer || panel.__searchBound) return;
    panel.__searchBound = true;

    var search = this.bindSheetForm(panel);
    drawer.addEventListener("tab:change", function (e) {
      if (e.detail.panelId === panel.id) search.show();
      else search.hide();
    });
    drawer.addEventListener("sheet:open", function () {
      if (!panel.hidden) search.show();
    });
    drawer.addEventListener("sheet:close", search.hide);
  },

  mainSearchPage: function () {
    var e = document.querySelector(".search-page");
    if (!e || e.__searchBound) return;
    e.__searchBound = true;
    var t = Object.create(this.form);
    t.container = e;
    t.hideSearchResultOnFocusOut = true;
    t.render();
  },
};

theme.search.form = {
  container: null,
  searchTerm: "",
  sectionId: "search-result",
  hideSearchResultOnFocusOut: false,
  render: function () {
    this.searchInput = this.container.querySelector(".search-form__input");
    this.searchResult = this.container.querySelector(".search-results");
    this.searchForm = this.container.querySelector(".search-form");
    this.clearButton = this.container.querySelector("[data-search-clear]");
    if (!this.searchInput || !this.searchResult || !this.searchForm) return;

    var debounced = theme.utilities.debounce(this.handleInputOnChange.bind(this), 300);
    this.searchInput.addEventListener("input", function () {
      this.updateQueryState();
      debounced();
    }.bind(this));
    this.searchInput.addEventListener("focus", this.inputFocus.bind(this));
    this.searchInput.addEventListener("focusout", this.inputFocusOut.bind(this));
    if (this.clearButton) {
      this.clearButton.addEventListener("click", function () {
        this.clear(true);
      }.bind(this));
    }
    this.updateQueryState();
  },
  updateQueryState: function () {
    this.searchForm.toggleAttribute("data-query", this.searchInput.value.trim().length > 0);
  },
  handleInputOnChange: function () {
    this.searchTerm = this.searchInput.value.trim();
    if (this.searchTerm.length) {
      this.getSearchResults();
    } else {
      this.abortRequest();
      this.searchResult.innerHTML = "";
    }
  },
  abortRequest: function () {
    if (this.request) this.request.abort();
    this.request = null;
    this.searchForm.removeAttribute("data-busy");
  },
  getSearchResults: function () {
    var self = this;
    var term = this.searchTerm;
    this.abortRequest();
    var controller = new AbortController();
    this.request = controller;
    this.searchForm.setAttribute("data-busy", "");

    fetch(
      "/search/suggest?q=" + encodeURIComponent(term) +
        "&resources[type]=product&section_id=" + this.sectionId,
      { signal: controller.signal }
    )
      .then(function (r) { return r.text(); })
      .then(function (html) {
        // O campo pode ter mudado ou sido limpo enquanto a resposta vinha
        if (self.request !== controller || !self.searchInput.value.trim()) return;
        self.searchResult.innerHTML = html;
        theme.utilities.applyAnimation();
      })
      .catch(function () {})
      .finally(function () {
        if (self.request === controller) {
          self.request = null;
          self.searchForm.removeAttribute("data-busy");
        }
      });
  },
  /* Limpa campo e sugestões. focus = true devolve o foco ao campo (clique em "Limpar"). */
  clear: function (focus) {
    this.abortRequest();
    this.searchInput.value = "";
    this.searchTerm = "";
    this.searchResult.innerHTML = "";
    this.updateQueryState();
    if (focus) this.searchInput.focus();
  },
  inputFocusOut: function () {
    var e = this;
    this.hideSearchResultOnFocusOut &&
      setTimeout(function () {
        e.searchResult.classList.add("search-results--hide");
      });
  },
  inputFocus: function () {
    var e = this;
    this.hideSearchResultOnFocusOut &&
      setTimeout(function () {
        e.searchResult.classList.remove("search-results--hide");
      });
  },
};

/**
 * Placeholder que se digita (form[data-typing-phrases]): escreve a frase revelando da esquerda
 * (1s, depois de 0.5s), mostra por um tempo, apaga (0.25s) e passa para a próxima. Cursor piscando.
 * Para quando o cliente toca/digita no campo ou há texto. Com prefers-reduced-motion não roda
 * (fica o placeholder fixo do campo). Retorna { start, stop } ou null.
 */
theme.search.typing = function (form) {
  if (!form || !form.dataset.typingPhrases) return null;
  var input = form.querySelector(".search-form__input");
  var text = form.querySelector(".search-form__typing-text");
  if (!input || !text) return null;

  var phrases;
  try {
    phrases = JSON.parse(form.dataset.typingPhrases).filter(Boolean);
  } catch (err) {
    return null;
  }
  if (!phrases.length) return null;

  var motion = window.matchMedia("(prefers-reduced-motion: reduce)");
  var TYPE_DELAY = 500, TYPE_TIME = 1000, HOLD_TIME = 2200, ERASE_TIME = 250;
  var index = 0, timer = null, animation = null, running = false, dismissed = false;

  function wait(ms, fn) {
    timer = window.setTimeout(fn, ms);
  }

  function animateWidth(from, to, duration, done) {
    if (animation) animation.cancel();
    text.style.width = to + "px";
    animation =text.animate(
      [{ width: from + "px" }, { width: to + "px" }],
      { duration: duration, easing: "linear", fill: "forwards" }
    );
    animation.onfinish = done;
  }

  function typePhrase() {
    if (!running) return;
    text.textContent = phrases[index];
    text.style.width = "auto";
    var full = text.scrollWidth;
    text.style.width = "0px";
    form.removeAttribute("data-typing-hold");
    wait(TYPE_DELAY, function () {
      animateWidth(0, full, TYPE_TIME, function () {
        if (!running) return;
        form.setAttribute("data-typing-hold", "");
        if (phrases.length === 1) return; // uma frase só: escreve e fica
        wait(HOLD_TIME, function () {
          form.removeAttribute("data-typing-hold");
          animateWidth(full, 0, ERASE_TIME, function () {
            index = (index + 1) % phrases.length;
            typePhrase();
          });
        });
      });
    });
  }

  function stop() {
    running = false;
    window.clearTimeout(timer);
    if (animation) animation.cancel();
    animation = null;
    form.removeAttribute("data-typing");
    form.removeAttribute("data-typing-hold");
    text.textContent = "";
  }

  function start() {
    if (running || dismissed || motion.matches || input.value.trim()) return;
    running = true;
    index = 0;
    form.setAttribute("data-typing", "");
    typePhrase();
  }

  // Interação real do cliente no campo encerra a animação até a gaveta fechar.
  // (O foco automático ao abrir a gaveta não conta: a frase continua até ele tocar ou digitar.)
  function dismiss() {
    dismissed = true;
    stop();
  }
  input.addEventListener("pointerdown", dismiss);
  input.addEventListener("input", dismiss);
  motion.addEventListener("change", function () {
    if (motion.matches) stop();
  });

  return {
    start: start,
    stop: function () {
      stop();
      dismissed = false;
    },
  };
};

document.addEventListener("shopify:section:load", function (event) {
  if (!event.target) return;
  if (event.target.querySelector(".search-page")) {
    theme.search.render();
  }
});

// Auto-init: script defer roda após DOM parseado.
theme.search.render();
